<template>
  <section class="mb-5">
    <FormulateForm
      ref="formFiscalTaxParameter"
      name="formFiscalTaxParameter"
      :model="fiscalTaxParameter"
      @submit="saveFiscalTaxParameter"
    >
      <b-card-actions
        action-collapse
        :title="$t('Informações Gerais')"
        :show-loading="isLoading"
      >
        <fiscal-tax-parameter-form :busy="isLoading" />
      </b-card-actions>

      <transition name="slide">
        <div v-if="fiscalTaxParameter.ratesVisible">
          <b-card-actions
            action-collapse
            :title="$t('CBS')"
            :show-loading="isLoading"
          >
            <fiscal-tax-parameter-cbs-form />
          </b-card-actions>

          <b-card-actions
            action-collapse
            :title="$t('IBS')"
            :show-loading="isLoading"
          >
            <fiscal-tax-parameter-ibs-form />
          </b-card-actions>

          <b-card-actions
            action-collapse
            :title="$t('Vigências de alíquotas')"
          >
            <fiscal-tax-parameter-rate-history />
          </b-card-actions>
        </div>
      </transition>

      <b-card-actions
        v-if="false"
        action-collapse
        :title="$t('Imposto Seletivo')"
        :show-loading="isLoading"
      >
        <fiscal-tax-parameter-selective-tax-form :busy="isLoading" />
      </b-card-actions>

      <b-card-actions
        v-if="false"
        action-collapse
        :title="$t('Regras de Destino')"
        :show-loading="isLoading"
      >
        <fiscal-tax-parameter-special-treatment-form />
      </b-card-actions>
    </FormulateForm>

    <e-crud-actions
      :busy="isLoading"
      @save="saveFiscalTaxParameter"
      @cancel="cancelHandle"
    />
  </section>
</template>

<script>
import BCardActions from '@/@core/components/b-card-actions/BCardActions.vue'
import { mapActions, mapState } from 'vuex'
import { alerts } from '@/mixins'
import { ECrudActions } from '@/views/components'
import FiscalTaxParameterForm from './components/FiscalTaxParameterForm.vue'
import FiscalTaxParameterCbsForm from './components/FiscalTaxParameterCbsForm.vue'
import FiscalTaxParameterIbsForm from './components/FiscalTaxParameterIbsForm.vue'
import FiscalTaxParameterRateHistory from './components/FiscalTaxParameterRateHistory.vue'
import FiscalTaxParameterSpecialTreatmentForm from './components/FiscalTaxParameterSpecialTreatmentForm.vue'
import FiscalTaxParameterSelectiveTaxForm from './components/FiscalTaxParameterSelectiveTaxForm.vue'

export default {
  name: 'FiscalTaxParameterMaintain',
  components: {
    BCardActions,
    FiscalTaxParameterForm,
    FiscalTaxParameterCbsForm,
    FiscalTaxParameterIbsForm,
    FiscalTaxParameterRateHistory,
    FiscalTaxParameterSpecialTreatmentForm,
    FiscalTaxParameterSelectiveTaxForm,
    ECrudActions,
  },

  mixins: [alerts],

  data() {
    return {
      saving: false,
      busy: false,
      isEdit: !!this.$router.currentRoute.params.ncm,
    }
  },

  computed: {
    ...mapState('pages/invoice/fiscalTaxParameters/fiscalTaxParameterMaintain', [
      'fiscalTaxParameter',
    ]),

    isLoading() {
      return this.busy || this.saving
    },
  },

  async mounted() {
    try {
      this.busy = true
      await this.fetchCombos()
      await this.fetchStates()
      if (this.isEdit) {
        await this.loadFiscalTaxParameter({
          ncm: this.$router.currentRoute.params.ncm,
          stateIdIbge: this.$router.currentRoute.params.stateIdIbge,
          cityIdIbge: this.$router.currentRoute.params.cityIdIbge,
        })
      } else {
        this.cleanState()
      }
    } catch (error) {
      this.showGenericError({ error })
    } finally {
      this.busy = false
    }
  },

  methods: {
    ...mapActions('pages/invoice/fiscalTaxParameters/fiscalTaxParameterMaintain', [
      'loadFiscalTaxParameter',
      'cleanState',
      'setFiscalTaxParameter',
    ]),
    ...mapActions('pages/invoice/fiscalTaxParameters', ['fetchCombos', 'fetchStates']),

    async saveFiscalTaxParameter() {
      if (await this.$refs.formFiscalTaxParameter.hasValidationErrors()) {
        this.$refs.formFiscalTaxParameter.showErrors()
        this.showInvalidDataMessage()
        return
      }

      try {
        this.saving = true

        const model = this.fiscalTaxParameter || {}

        const body = {
          ncm: model.ncm,
          stCbsIbsCode: model.stCbsIbsCode,
          fiscalClassificationCbsIbsCode: model.fiscalClassificationCbsIbsCode,
          cbsPercent: model.cbsPercent,
          cbsReductionPercent: model.cbsReductionPercent,
          cbsDeferralPercent: model.cbsDeferralPercent,
          ibsStatePercent: model.ibsStatePercent,
          ibsStateReductionPercent: model.ibsStateReductionPercent,
          ibsStateDeferralPercent: model.ibsStateDeferralPercent,
          ibsMunicipalPercent: model.ibsMunicipalPercent,
          ibsMunicipalReductionPercent: model.ibsMunicipalReductionPercent,
          ibsMunicipalDeferralPercent: model.ibsMunicipalDeferralPercent,
          stSelectiveTaxCode: model.stSelectiveTaxCode,
          fiscalClassificationSelectiveTaxCode: model.fiscalClassificationSelectiveTaxCode,
          selectiveTaxType: model.selectiveTaxType,
          selectiveTaxPercent: model.selectiveTaxPercent,
          selectiveTaxValuePerUnit: model.selectiveTaxValuePerUnit,
          specificDestinationRules: (model.specificDestinationRules || []).map(r => ({
            ncm: model.ncm,
            stateIdIbge: r.stateIdIbge,
            cityIdIbge: r.cityIdIbge,
            stCbsIbsCode: r.stCbsIbsCode,
            fiscalClassificationCbsIbsCode: r.fiscalClassificationCbsIbsCode,
            cbsPercent: r.cbsPercent,
            cbsReductionPercent: r.cbsReductionPercent,
            cbsDeferralPercent: r.cbsDeferralPercent,
            ibsStatePercent: r.ibsStatePercent,
            ibsStateReductionPercent: r.ibsStateReductionPercent,
            ibsStateDeferralPercent: r.ibsStateDeferralPercent,
            ibsMunicipalPercent: r.ibsMunicipalPercent,
            ibsMunicipalReductionPercent: r.ibsMunicipalReductionPercent,
            ibsMunicipalDeferralPercent: r.ibsMunicipalDeferralPercent,
            stSelectiveTaxCode: r.stSelectiveTaxCode,
            fiscalClassificationSelectiveTaxCode: r.fiscalClassificationSelectiveTaxCode,
            selectiveTaxType: r.selectiveTaxType,
            selectiveTaxPercent: r.selectiveTaxPercent,
            selectiveTaxValuePerUnit: r.selectiveTaxValuePerUnit,
          })),
          active: model.active !== false,
        }

        if (this.isEdit) {
          await this.$http.put(
            `/api/tax/fiscal-tax-parameters/${this.$router.currentRoute.params.ncm}`,
            body
          )
        } else {
          await this.$http.post('/api/tax/fiscal-tax-parameters', body)
        }

        this.showSuccess({
          message: this.$t(`${this.isEdit ? 'Atualização' : 'Inclusão'} realizada com sucesso`),
        })
        this.$router.back()
        await this.$store.dispatch('pages/invoice/fiscalTaxParameters/fetchFiscalTaxParameters')
      } catch (error) {
        this.showError({ error })
      } finally {
        this.saving = false
      }
    },

    cancelHandle() {
      this.cleanState()
      this.$router.back()
    },
  },
}
</script>

<style lang="scss" scoped>
.slide-enter-active,
.slide-leave-active {
  transition: all 300ms ease;
  max-height: 1000px;
  overflow: hidden;
}

.slide-enter,
.slide-leave-to {
  max-height: 0;
  opacity: 0;
  transform: translateY(-20px);
}

.slide-enter-to,
.slide-leave {
  max-height: 100vh;
  opacity: 1;
  transform: translateY(0);
}
</style>
